import { useEffect, useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useAppContext } from "hooks/useContext";
import useAgencyState from "./useAgencyState";
import { STATUS_ACTIVE, SUBSTATUS_READY_FOR_WORK } from "utils/constantValues";

const useAgencyTeam = ({}) => {
  const navigate = useNavigate();
  const [loadPage, setLoadPage] = useState(false);
  const {
    user,
    getUserDomains,
    getUserSubDomains,
    userDetails,
    userDomains,
    userSubDomains,
  } = useAppContext();

  const userId = user?.id;

  const isRedirect =
    !userDetails.agencyId ||
    (userDetails?.status &&
      (STATUS_ACTIVE !== userDetails?.status ||
        SUBSTATUS_READY_FOR_WORK !== userDetails?.subStatus));

  const {
    initLoading,
    setFilterQuery,
    filterQuery,
    defaultFilterQuery,
    totalCount,
    listAgencyTeam,
    users,
    resetOnUnmount,
    setUsers,
  } = useAgencyState({});

  const fetchUserDetails = useCallback(async () => {
    setLoadPage(true);
    try {
      await getUserDomains(userId);
      await getUserSubDomains(userId);
    } catch (err) {
      console.error(err);
    } finally {
      setLoadPage(false);
    }
  }, [userId]);

  useEffect(() => {
    if (userId && isRedirect) {
      navigate("/");
      return;
    }
    if (userId) {
      listAgencyTeam(filterQuery);
    }
  }, [userId, isRedirect, filterQuery]);

  useEffect(() => {
    fetchUserDetails();

    return () => {
      resetOnUnmount();
    };
  }, []);

  return {
    totalCount,
    users,
    initLoading,
    filterQuery,
    setFilterQuery,
    defaultFilterQuery,
    setUsers,
    userDetails,
    userDomains,
    userSubDomains,
    loadPage,
  };
};

export default useAgencyTeam;
